import React from "react";
import styled from "styled-components";

import { Map, MapMarker, ZoomControl, MapTypeControl } from 'react-kakao-maps-sdk';

import { EMAIL, PHONE, ADDRESS, BREAK_POINTS } from "../../constants";
import { COPY, OPEN_IN_NEW } from '../../icons';

const location = { lat: 37.556410, lng: 126.968178 };
const mapStyle = { width: '100%', height: '600px' };
const mapLevel = 2;

const Container = styled.div`
  width: 100%;
  padding: 84px 0 0 0;

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    padding: 44px 0 0 0;
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    padding: 24px 0 0 0;
  }
`;

const ContentWrapper = styled.div`
  max-width: 1180px;
  margin: 0 auto;
`;

const Section = styled.section`
  display: flex;
  margin-bottom: 83px;

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    margin-bottom: 60px;
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    flex-direction: column;
    align-items: center;
    margin-bottom: 40px;
  }
`;

const Label = styled.h2`
  width: 200px;
  font-family: NanumSquareNeo;
  font-size: 24px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: -0.83px;
  color: #969696;

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    width: 160px;
    font-size: 22px;
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    width: auto;
    font-size: 16px;
    margin-bottom: 20px;
  }
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  font-family: NanumSquareNeo;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: -0.38px;
  color: #505050;

  img {
    width: 24px;
    height: 24px;
    margin-left: 10px;
    cursor: pointer;
  }

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    margin-bottom: 30px;
    font-size: 16px;

    img {
      width: 20px;
      height: 20px;
    }
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    margin-bottom: 20px;
    font-size: 12px;

    img {
      width: 20px;
      height: 20px;
    }
  }
`;

const InfoWrapper = styled.div``;

const InfoInnerWrapper = styled.div`
  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const MapContainer = styled.div`
  width: 100vw;
  height: 600px;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;

  /* @media (max-width: ${BREAK_POINTS.TABLET}px) {
    height: 500px;
    margin-bottom: -80px;
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    height: 400px;
    margin-bottom: -60px;
  } */
`;

const ContactPresenter = ({ handleCopy, handleAddressClick }) => {
  return (
    <Container>
      <ContentWrapper>
          <InfoWrapper>
          <Section>
            <Label>CONTACT</Label>
            <InfoInnerWrapper>
              <InfoItem>
                {EMAIL}
                <img src={COPY} alt="copy" onClick={() => handleCopy(EMAIL)} />
              </InfoItem>
              <InfoItem>
                {PHONE}
                <img src={COPY} alt="copy" onClick={() => handleCopy(PHONE)} />
              </InfoItem>
            </InfoInnerWrapper>
          </Section>

          <Section>
            <Label>OFFICE</Label>
            <InfoInnerWrapper>
              <InfoItem>
                {ADDRESS}
                <img src={OPEN_IN_NEW} alt="open in new" onClick={handleAddressClick} />
              </InfoItem>
            </InfoInnerWrapper>
          </Section>
        </InfoWrapper>

        <MapContainer>
          <Map center={location} style={mapStyle} level={mapLevel}>
            <ZoomControl position={'LEFT'}/>
            <MapTypeControl position={'RIGHT'}/>
            <MapMarker position={location} />
          </Map>
        </MapContainer>
      </ContentWrapper>
    </Container>
  );
};

export default ContactPresenter;